import Image from 'next/image';

import { UnstyledButton } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';

import { useStyles, ICON_SIZE } from './PromoCallouts.styles';

interface PromoCalloutRowProps {
  icon: string;
  title: string;
  availableLabel: string;
  subtitle: string;
  learnMoreLabel: string;
  onOpen: () => void;
  dataTestId?: string;
}

export function PromoCalloutRow({
  icon,
  title,
  availableLabel,
  subtitle,
  learnMoreLabel,
  onOpen,
  dataTestId,
}: PromoCalloutRowProps) {
  const { classes } = useStyles();

  return (
    <UnstyledButton
      type="button"
      className={classes.row}
      onClick={onOpen}
      data-test-id={dataTestId}
    >
      <div className={classes.iconContainer}>
        <Image src={icon} alt="" fill sizes={`${ICON_SIZE}px`} className={classes.icon} />
      </div>
      <div className={classes.contentContainer}>
        <div className={classes.textContent}>
          <div className={classes.titleRow}>
            <Text variant="subhead-large" c="gray2.6">
              {title}
            </Text>
            <Text variant="subhead-x-small" className={classes.availableTag}>
              {availableLabel}
            </Text>
          </div>
          <Text variant="body-medium" c="gray2.7">
            {subtitle}
          </Text>
        </div>
        <Text variant="subhead-medium" c="blue.7" className={classes.learnMore}>
          {learnMoreLabel}
        </Text>
      </div>
    </UnstyledButton>
  );
}
